import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  timeout: 30000,
});

// Добавляем JWT токен к каждому запросу
api.interceptors.request.use(config => {
  const token = localStorage.getItem('rc_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Редирект на логин при 401
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('rc_token');
      localStorage.removeItem('rc_user');
      window.location.href = '/admin/login';
    }
    return Promise.reject(err);
  }
);

// Auth
export const login = (username, password) =>
  api.post('/auth/login', { username, password });

export const getMe = () => api.get('/auth/me');

// Regcard
export const getTodayArrivals = (hotelId, refresh = false) =>
  api.get(`/regcard/today/${hotelId}${refresh ? '?refresh=1' : ''}`);

export const generateToken = (bookingNumber, hotelId) =>
  api.post('/regcard/token', { bookingNumber, hotelId });

export const getCardByToken = (token) =>
  api.get(`/regcard/card/${token}`);

export const signCard = (data) =>
  api.post('/regcard/sign', data);

export const getArchive = (params) =>
  api.get('/regcard/archive', { params });

export const getPdfUrl = (fileName) => {
  const token = localStorage.getItem('rc_token');
  return `/api/regcard/pdf/${fileName}?token=${token}`;
};

// Guests (superadmin only)
export const getGuests = (params) =>
  api.get('/guests', { params });

export const getGuest = (guestId) =>
  api.get(`/guests/${guestId}`);

export const getGuestStats = () =>
  api.get('/guests/stats/summary');

export const getGuestsCsvUrl = (params) => {
  const q = new URLSearchParams(params).toString();
  return `/rc/api/guests/export/csv?${q}`;
};

export default api;
